import type { ForwardDemandView } from "../api/types";

/**
 * G-132 — how much the "To order" chip has to say: what to buy, what to move
 * between shops, and the orders that cannot be checked. Zero means the card
 * would render nothing, and the chip is not shown (one rule for both).
 */
export function forwardDemandCount(view: ForwardDemandView): number {
  return (
    view.purchases.length +
    view.transfers.length +
    view.orders.filter((o) => o.verdict === "UNCHECKABLE").length
  );
}
